import { ResetUserPassPostRequestModel, ResetUserPassPutRequestModel, } from "@/features/user/services/user-model";
import { ResetUserPassApi } from "@/features/user/services/reset-pass-api";

export class ResetUserPassService {
  private resetUserPassApi = new ResetUserPassApi();

  /**
   * パスワードリセット用メール送信（パスワードを忘れた方はこちら）
   */
  public async sendResetUserPassMail(param: ResetUserPassPostRequestModel) {
    return await this.resetUserPassApi.postSendResetUserPassMail(param);
  }

  /**
   * パスワードリセット（パスワードを忘れた方はこちら）
   */
  public async resetUserPass(param: ResetUserPassPutRequestModel) {
    return await this.resetUserPassApi.putResetUserPass(param);
  }
}